/**
 * Custom table components.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { ReactElement } from 'react'
import './IampTable.css'

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

/**
 * A column header definition with an icon and a title.
 */
export interface IampTableColumnHeader {
  className?: string
  icon?: ReactElement
  title: string
}

export const IampHeaderIconTitle = (props: IampTableColumnHeader) => {
  return (
    <th className={props.className ?? ''}>
      <div className="header-icon-title">
        {props.icon ?? ''}
        {props.title}
      </div>
    </th>
  )
}
